import React from 'react';
import { Link } from 'react-router-dom';
import LogoutButton from '../buttons/LogoutButton';

class TopBarComment extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className='top-bar'>
                <div>
                    <Link to={`/post/${this.props.postUuid}`}>Back to Post</Link>
                </div>
                <div>
                    <LogoutButton />
                </div>
            </div>
        );
    }
}

export default TopBarComment;
